import React from 'react'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import {
  faAdd,
  faAt,
  faCirclePlus,
  faHistory,
  faHouse,
  faPencilAlt,
  faPhone,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { getCustomers } from 'client/utils/api-routes-customers'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  $DCprimaryColor,
  DcButton,
  DcDiv,
  DcFlexBox,
  DcIcon,
  DcInput,
  DcOverlaySlider,
  Link,
  PixelIcon,
  PixelText,
  PixelTooltip,
  DcText,
  colors,
} from 'pixel-base'
import ClickOutside from 'rechat-react-click-outside'
import styled from 'styled-components'

import { get } from 'utils/api-routes.util'

import EditCustomerInfo from './subComponents/EditCustomerInfo'
import SummaryTable from './subComponents/SummaryTable'
import { Customer, OrderDetail } from '../../../../../decl'
import AddNewCustomer from '../../../customers/pages/details/components/AddNewCustomer'
import CustomerAddresses from '../components/subComponents/common/CustomerAddresses'

interface ISearchingCustomerList {
  customer_id: number
  first_name: string
  last_name: string
  email: string
  phone: string
  company: string
  balance: number
}
interface ICustomerResponse {
  data: ISearchingCustomerList[]
}
interface IProps {
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  setNewOrderData: (newOrderData: OrderDetail) => void
  newOrderData: OrderDetail
  isItInvoice: boolean
  invoiceNew: boolean
  customerData: Customer
  setCustomerData: (customerData: Customer) => void
  setIsCustomerAdded: (isCustomerAdded: boolean) => void
}
const CustomerInformation = (props: IProps) => {
  const {
    details,
    detailID,
    setDetails,
    newOrder,
    setNewOrderData,
    newOrderData,
    isItInvoice,
    invoiceNew,
    customerData,
    setCustomerData,
    setIsCustomerAdded,
  } = props

  const [isCustomerAdd, setIsCustomerAdd] = React.useState(false)
  const [showOptions, setShowOptions] = React.useState(false)
  const [customerLoading, setCustomerLoading] = React.useState(false)
  const [summaryOrderHistory, setSummaryOrderHistory] = React.useState(false)
  const { state } = React.useContext(OrdersContext)
  const [customer, setCustomer] = React.useState<ISearchingCustomerList[]>([
    {
      company: '',
      customer_id: 0,
      email: '',
      first_name: '',
      last_name: '',
      phone: '',
      balance: 0,
    },
  ])
  const [customerId, setCustomerId] = React.useState<any>(0)
  const [orderId, setOrderId] = React.useState<any>(0)
  const [origin, setOrigin] = React.useState<any>('order')
  const [customerDetail, setCustomerDetail] = React.useState<any>(null)
  const [showAddNewAddressPopup, setShowAddNewAddressPopup] =
    React.useState<any>(false)
  const [showEditOrderAddress, setShowEditOrderAddress] = React.useState(false)
  type AddressesState = {
    billingAddress?: any
    shippingAddress?: any
  }[]

  const [addresses, setAddresses] = React.useState<AddressesState>([
    {
      billingAddress: undefined,
    },
    { shippingAddress: undefined },
  ])
  const [OrderAddresses, setOrderAddresses] = React.useState({
    shipping_address: {},
    billing_address: {},
    is_billing_address_same: true,
  })
  const [countries, setCountries] = React.useState({
    list: [],
    default: '',
  })

  // Function to update the shipping address
  const updateShippingAddress = (newShippingAddress) => {
    setAddresses((prevAddresses) => [
      prevAddresses[0],
      {
        shippingAddress: newShippingAddress,
      },
    ])
  }
  const updateBillingAddress = (newBillingAddress) => {
    setAddresses((prevAddresses) => [
      {
        billingAddress: newBillingAddress,
      },
      prevAddresses[1],
    ])
  }
  const updateOrderAddresses = (newBillingAddress) => {
    setOrderAddresses(newBillingAddress)
  }

  React.useEffect(() => {
    if (isCustomerAdd) {
      if (typeof setIsCustomerAdded === 'function')
        setIsCustomerAdded(isCustomerAdd)
    }
  }, [isCustomerAdd])
  React.useEffect(() => {
    if (!newOrder && !isItInvoice) {
      const billingAddress = {
        shipping_address: details?.shipping,
        billing_address: details?.billing,
        is_billing_address_same: details?.is_billing_address_same,
      }
      updateOrderAddresses(billingAddress)
      if (details?.shipping) {
        const shippingAddress = {
          ...details.shipping,
          address_type: 'Shipping',
        }
        updateShippingAddress(shippingAddress)
      }
      setOrigin('order')
      setOrderId(details?.number)
      setCustomerId(details?.customer_id)
    } else if (
      newOrder &&
      !isItInvoice &&
      newOrderData.billing.first_name !== null
    ) {
      if (newOrderData?.billing) {
        const billingAddress = {
          ...newOrderData.billing,
          address_type: 'Billing',
        }
        updateBillingAddress(billingAddress)
      }

      if (newOrderData?.shipping) {
        const shippingAddress = {
          ...newOrderData.shipping,
          address_type: 'Shipping',
        }
        setCustomerId(newOrderData.customer_id)

        updateShippingAddress(shippingAddress)
      }
    } else if (!newOrder && isItInvoice) {
      // Invoice Detail page

      if (details?.billing_address) {
        const billingAddress = {
          ...details?.billing_address,
          address_type: 'Billing',
        }
        updateBillingAddress(billingAddress)
      }
      if (details?.shipping_address) {
        const shippingAddress = {
          ...details?.billing_address,
          address_type: 'Shipping',
        }
        updateShippingAddress(shippingAddress)
      }
      setCustomerId(details.customer_id)
    } else if (invoiceNew) {
      //newInvoice page
      if (details?.billing_address_id) {
        const billingAddress = {
          ...details?.billing,
          address_type: 'Billing',
        }
        updateBillingAddress(billingAddress)
      }

      if (details?.shipping_address_id) {
        const shippingAddress = {
          ...details?.shipping,
          address_type: 'Shipping',
        }
        updateShippingAddress(shippingAddress)
      }
      setCustomerId(details.customer_id)
    }
  }, [newOrder, isItInvoice, details, newOrderData])

  // Hardcode Pakistan as the only country
  React.useEffect(() => {
    setCountries({
      list: [{ name: 'Pakistan', two_letter_abbreviation: 'PK' }],
      default: 'PK',
    })
  }, [])

  const handleSearch = (query) => {
    setCustomerLoading(true)
    getCustomers({ page: 0, perPage: 100, search: query }).subscribe(
      (res: { response: ICustomerResponse | any }) => {
        if (res.response.data) {
          const customers = res.response?.data?.filter(
            (item: ISearchingCustomerList) => item.first_name !== null,
          )
          setCustomer([...customers])
        }
        setCustomerLoading(false)
      },
    )
  }

  const getWhatsappNumber = (phone) => {
    let phoneNumber = phone
    if (phone?.charAt(0) === '0') {
      phoneNumber = phone?.slice(1)
    }
    if (phone?.slice(0, 2) !== '92') {
      phoneNumber = `92${phoneNumber}`
    }
    return phoneNumber
  }

  const [cities, setCities] = React.useState<any>([])
  React.useEffect(() => {
    setCities(
      state?.citiesList?.map((city) => {
        return { name: city.toLowerCase() }
      }),
    )
  }, [state])
  const fetchCustomerData = (customerId) => {
    get(`/customer/${customerId}`).subscribe((res: any) => {
      if (setCustomerData) {
        setCustomerData(res.response.data)
      }
      const billingAddress = res.response.data.addresses.find(
        (address: any) => address.address_type == 'Billing',
      )
      const shippingAddress = res.response.data.addresses.find(
        (address: any) => address.address_type == 'Shipping',
      )
      setNewOrderData({
        ...newOrderData,
        billing: {
          ...billingAddress,
          phone: res.response?.data?.phone,
          postcode: billingAddress?.zip,
          email: res.response?.data?.email,
          address1:
            res.response?.data?.billing_address?.address1 ||
            billingAddress?.address1,
          address2:
            res.response?.data?.billing_address?.address2 ||
            billingAddress?.address2,
        },
        shipping: {
          ...shippingAddress,
          phone: res.response?.data?.phone,
          postcode: billingAddress?.zip,
          email: res.response?.data?.email,
          address1:
            res.response?.data?.shipping_address?.address1 ||
            shippingAddress?.address1,
          address2:
            res.response?.data?.shipping_address?.address2 ||
            shippingAddress?.address2,
        },
        shipping_address_id: shippingAddress?.address_id,
        billing_address_id: billingAddress?.address_id,
        email: res.response?.data?.email,
        customer_id: res.response?.data?.customer_id,
      })
      setDetails({
        ...details,
        billing: {
          ...billingAddress,
          phone: res.response?.data?.phone,
          postcode: billingAddress?.zip,
          email: res.response?.data?.email,
          address1:
            res.response?.data?.billing_address?.address1 ||
            billingAddress?.address1,
          address2:
            res.response?.data?.billing_address?.address2 ||
            billingAddress?.address2,
        },
        shipping: {
          ...shippingAddress,
          phone: res.response?.data?.phone,
          postcode: billingAddress?.zip,
          email: res.response?.data?.email,
          address1:
            res.response?.data?.shipping_address?.address1 ||
            shippingAddress?.address1,
          address2:
            res.response?.data?.shipping_address?.address2 ||
            shippingAddress?.address2,
        },
        shipping_address_id: shippingAddress?.address_id,
        billing_address_id: billingAddress?.address_id,
        email: res.response?.data?.email,
        customer_id: res.response?.data?.customer_id,
      })
      setIsCustomerAdd(true)
    })
  }

  React.useEffect(() => {
    if (details) {
      setCustomerDetail(details)
    }
  }, [details])

  const getUniqueCustomers = (customers: any[], key: string) => {
    const seen = new Set()
    return customers.filter((customer) => {
      const value = customer[key]
      if (seen.has(value)) {
        return false
      }
      seen.add(value)
      return true
    })
  }

  return (
    <Container>
      <InnerSection>
        <SectionHeader>
          <PixelText
            textSize="16px"
            color="rgba(0, 0, 0, 0.84)"
            style={{ fontWeight: '600', padding: '10px' }}
          >
            Customer
          </PixelText>
          {!newOrder &&
            isItInvoice &&
            (details?.invoice_status == 'open' ? (
              <Link style={{ marginRight: '20px' }}>
                <PixelIcon
                  color={$DCprimaryColor}
                  showTooltip
                  tooltip="Edit"
                  icon={faPencilAlt}
                />
              </Link>
            ) : (
              <Link
                size="sm"
                variant="outline"
                style={{
                  marginRight: '20px',
                  border: 'none',
                  cursor: 'not-allowed',
                }}
              >
                <PixelIcon
                  color={'lightgrey'}
                  showTooltip
                  tooltip="Invoice is closed"
                  icon={faPencilAlt}
                />
              </Link>
            ))}

          {!isItInvoice && (
            <>
              {!newOrder && (
                <CloseButton>
                  <Link
                    onClick={() => {
                      setSummaryOrderHistory(true)
                    }}
                  >
                    <PixelIcon
                      showTooltip
                      tooltip="Show Customer History"
                      color={$DCprimaryColor}
                      icon={faHistory}
                    />
                  </Link>
                </CloseButton>
              )}
            </>
          )}
        </SectionHeader>

        <InnerSectionContent>
          {newOrder ? (
            // ------------------------- new order --------------------------------
            <>
              {!isCustomerAdd ? (
                <ClickOutside onClickOutside={() => setShowOptions(false)}>
                  <DcInput
                    required
                    type={'text'}
                    name={'name'}
                    as={'typeahead'}
                    labelKey={'first_name'}
                    data={getUniqueCustomers(customer, 'customer_id')}
                    placeholder={'Search Customer'}
                    handleSearch={handleSearch}
                    isLoading={customerLoading}
                    onFocus={() => {
                      setShowOptions(true)
                    }}
                    open={showOptions}
                    formatter={(option) => {
                      return (
                        <div>
                          {option?.customer_id === 0 && (
                            <CustomTitle
                              onClick={() => {
                                setShowEditOrderAddress(true)
                              }}
                            >
                              <PixelIcon size="14px" icon={faCirclePlus} /> Add
                              New Customer
                            </CustomTitle>
                          )}
                          {option?.customer_id !== 0 && (
                            <div>
                              <SectionRow>
                                <SectionBlock>
                                  Name:&nbsp;
                                  <strong>
                                    {option?.first_name}&nbsp;
                                    {option?.last_name}
                                  </strong>
                                </SectionBlock>
                              </SectionRow>
                              <SectionRow>
                                <SectionBlock>
                                  Customer id:&nbsp;
                                  <strong> {option?.customer_id}</strong>
                                </SectionBlock>
                              </SectionRow>
                              <SectionRow>
                                <SectionBlock>
                                  Phone:&nbsp; <strong>{option?.phone}</strong>
                                </SectionBlock>
                              </SectionRow>
                            </div>
                          )}
                        </div>
                      )
                    }}
                    onChange={(array) => {
                      if (array.length > 0) {
                        setShowOptions(false)
                        if (array[0].customer_id !== 0) {
                          if (invoiceNew || newOrder) {
                            fetchCustomerData(array[0].customer_id)
                          }
                          if (newOrderData?.shipping?.first_name !== '') {
                            setIsCustomerAdd(true)
                          }
                        }
                      }
                    }}
                  />
                </ClickOutside>
              ) : (
                <ChangeCustomer>
                  <Left>
                    <AddressItem color="primary">
                      {newOrderData?.shipping?.first_name
                        ? newOrderData?.shipping?.first_name
                        : customerData?.first_name}
                      &nbsp;
                      {newOrderData?.shipping?.last_name
                        ? newOrderData?.shipping?.last_name
                        : customerData?.last_name}
                    </AddressItem>
                    <AddressItem>{customerData?.phone}</AddressItem>

                    <AddressItem>
                      Customer id: <strong>{newOrderData?.customer_id}</strong>
                    </AddressItem>
                  </Left>
                  <Right>
                    <DcButton
                      size="sm"
                      onClick={() => {
                        setIsCustomerAdd(false)
                        setCustomerDetail({})
                        setNewOrderData({
                          ...newOrderData,
                          customer_id: null,
                          billing: {
                            address_id: null,
                            address1: null,
                            city: null,
                            country: null,
                            country_code: 'PK',
                            email: null,
                            first_name: null,
                            last_name: null,
                            phone: null,
                            postcode: null,
                          },
                          shipping: {
                            address_id: null,
                            address1: null,
                            city: null,
                            country: null,
                            country_code: 'PK',
                            email: null,
                            first_name: null,
                            last_name: null,
                            phone: null,
                            postcode: null,
                          },
                        })
                      }}
                    >
                      Change Customer
                    </DcButton>
                  </Right>
                </ChangeCustomer>
              )}
            </>
          ) : (
            <>
              <AddressItem color="primary">
                {customerDetail?.shipping?.first_name
                  ? customerDetail?.shipping?.first_name
                  : customerData?.first_name}
                &nbsp;
                {customerDetail?.shipping?.last_name
                  ? customerDetail?.shipping?.last_name
                  : customerData?.last_name}
              </AddressItem>
              <AddressItem>{customerData?.phone}</AddressItem>
              {customerDetail?.customer_id && (
                <AddressItem>
                  Customer id: <strong>{customerDetail?.customer_id}</strong>
                </AddressItem>
              )}
            </>
          )}
        </InnerSectionContent>
      </InnerSection>

      <>
        {isItInvoice ? (
          addresses.map((address, i) => {
            const addressType =
              Object.keys(address)[0] === 'billingAddress'
                ? 'billing'
                : 'shipping'

            return (
              <CustomerAddresses
                key={i}
                address={
                  addressType === 'billing'
                    ? address.billingAddress
                    : address.shippingAddress
                }
                customerId={customerId}
                countries={countries}
                addressType={addressType}
                isItInvoice={isItInvoice}
                customerData={customerData}
                newOrder={newOrder}
                setAddresses={setAddresses}
                details={details}
                origin={origin}
                orderId={orderId}
                invoiceStatus={details?.invoice_status}
              />
            )
          })
        ) : newOrder && !isCustomerAdd ? (
          ''
        ) : (
          <>
            <>
              <DcFlexBox
                style={{
                  flexDirection: 'column',
                  alignContent: 'center',
                  borderBottom: `1px solid ${colors.grayBorderLight}`,
                  width: '100%',
                  padding: '10px 0px',
                }}
              >
                {
                  <DcFlexBox
                    style={{
                      justifyContent: 'space-between',
                    }}
                  >
                    <PixelText
                      textSize="16px"
                      color="rgba(0, 0, 0, 0.84)"
                      style={{ fontWeight: '600', padding: '10px' }}
                    >
                      Shipping Address
                    </PixelText>

                    <>
                      <DcFlexBox
                        style={{
                          padding: '10px',
                          marginRight: '10px',
                          cursor: 'pointer',
                          color: 'rgba(0, 0, 0, 0.84)',
                          fontSize: '20px',
                          fontWeight: '600',
                          gap: '10px',
                          heigh: 'auto',
                          width: 'auto',
                        }}
                      >
                        {!newOrder &&
                          details?.shipping?.first_name === null && (
                            <DcButton
                              variant="link"
                              size="sm"
                              padding="0px"
                              onClick={() => {
                                setShowAddNewAddressPopup(true)
                              }}
                            >
                              <PixelIcon
                                color={colors.black}
                                width="15px"
                                icon={faAdd}
                              />
                            </DcButton>
                          )}

                        {details?.is_editable && (
                          <DcButton
                            variant="link"
                            padding="0px"
                            size="sm"
                            onClick={() => {
                              setShowEditOrderAddress(true)
                            }}
                          >
                            <PixelIcon
                              width="15px"
                              color={colors.black}
                              icon={faPencilAlt}
                            />
                          </DcButton>
                        )}
                      </DcFlexBox>
                    </>
                  </DcFlexBox>
                }

                {details?.shipping?.first_name !== null && (
                  <DcFlexBox
                    style={{ flexDirection: 'column', marginLeft: '10px' }}
                  >
                    <DcFlexBox
                      style={{
                        justifyContent: 'flex-start',
                        marginTop: '3px',
                        gap: '7px',
                      }}
                    >
                      <DcDiv>
                        <PixelIcon
                          style={{ marginBottom: '10px' }}
                          color={colors.black}
                          icon={faUser}
                        />
                      </DcDiv>
                      <DcDiv
                        style={{
                          fontSize: '12px',
                          fontWeight: '400',
                          color: colors.black,
                        }}
                      >
                        {details?.shipping?.first_name}
                        &nbsp;
                        {details?.shipping?.last_name}
                      </DcDiv>
                    </DcFlexBox>
                    <DcFlexBox
                      style={{
                        justifyContent: 'flex-start',
                        marginTop: '3px',
                        gap: '5px',
                      }}
                    >
                      <div>
                        <PixelIcon
                          style={{ marginBottom: '10px' }}
                          color={colors.black}
                          icon={faPhone}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: '400',
                          color: colors.black,
                        }}
                      >
                        <DcFlexBox
                          height="auto"
                          justifyContent="flex-start"
                          gap="5px"
                        >
                          <DcText>{details?.shipping?.phone || '--'}</DcText>{' '}
                          <PixelTooltip
                            style={{ width: 'auto' }}
                            tooltipText="Go to whatsapp"
                          >
                            <a
                              href={`https://wa.me/${getWhatsappNumber(
                                details?.shipping?.phone,
                              )}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <PixelIcon
                                color={colors.success}
                                icon={faWhatsapp}
                              />
                            </a>
                          </PixelTooltip>
                        </DcFlexBox>
                      </div>
                    </DcFlexBox>

                    <DcFlexBox
                      style={{
                        justifyContent: 'flex-start',
                        marginTop: '3px',
                        gap: '7px',
                      }}
                    >
                      <div>
                        <PixelIcon
                          style={{ marginBottom: '10px' }}
                          color={colors.black}
                          icon={faAt}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: '400',
                          color: colors.black,
                        }}
                      >
                        {isItInvoice
                          ? customerData?.email
                          : details?.shipping?.email}
                      </div>
                    </DcFlexBox>

                    <DcFlexBox
                      style={{
                        justifyContent: 'flex-start',
                        marginTop: '3px',
                        gap: '4px',
                      }}
                    >
                      <div>
                        <PixelIcon
                          style={{ marginBottom: '10px' }}
                          color={colors.black}
                          icon={faHouse}
                        />
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: '400',
                          color: colors.black,
                        }}
                      >
                        {details?.shipping?.address1} &nbsp;
                        <strong>
                          {details?.shipping?.city}-
                          {details?.shipping?.state &&
                            details?.shipping?.state.trim() !== '' && (
                              <>{details?.shipping?.state} -</>
                            )}
                          {details?.shipping?.postcode &&
                          details?.shipping?.postcode.trim() !== '' ? (
                            <>
                              {details?.shipping?.postcode}{' '}
                              {details?.shipping?.zip}-
                            </>
                          ) : (
                            ''
                          )}
                          {newOrder
                            ? details?.shipping?.country_name
                            : details?.shipping?.country}
                        </strong>
                      </div>
                    </DcFlexBox>
                  </DcFlexBox>
                )}
              </DcFlexBox>
              <DcFlexBox
                style={{
                  flexDirection: 'column',
                  alignContent: 'center',
                  borderBottom: `1px solid ${colors.grayBorderLight}`,
                  width: '100%',
                  padding: '10px 0px',
                }}
              >
                {
                  <DcFlexBox
                    style={{
                      justifyContent: 'space-between',
                    }}
                  >
                    <PixelText
                      textSize="16px"
                      color="rgba(0, 0, 0, 0.84)"
                      style={{ fontWeight: '600', padding: '10px' }}
                    >
                      Billing Address
                    </PixelText>

                    <>
                      <DcFlexBox
                        style={{
                          padding: '10px',
                          marginRight: '10px',
                          cursor: 'pointer',
                          color: 'rgba(0, 0, 0, 0.84)',
                          fontSize: '20px',
                          fontWeight: '600',
                          gap: '10px',
                          heigh: 'auto',
                          width: 'auto',
                        }}
                      >
                        {!newOrder &&
                          newOrderData?.billing?.first_name !== null && (
                            <DcButton
                              variant="link"
                              // padding="0px"
                              onClick={() => {
                                setShowAddNewAddressPopup(true)
                              }}
                            >
                              <DcIcon icon={faAdd} />
                            </DcButton>
                          )}
                        {details?.is_editable && (
                          <DcButton
                            variant="link"
                            padding="0px"
                            onClick={() => {
                              setShowEditOrderAddress(true)
                            }}
                          >
                            <PixelIcon
                              color={colors.black}
                              icon={faPencilAlt}
                            />
                          </DcButton>
                        )}
                      </DcFlexBox>
                    </>
                  </DcFlexBox>
                }

                {details?.is_billing_address_same ? (
                  <PixelText
                    style={{
                      fontSize: '12px',
                      padding: '10px',
                    }}
                  >
                    Same As Shipping
                  </PixelText>
                ) : (
                  details?.billing?.first_name !== null && (
                    <DcFlexBox
                      style={{ flexDirection: 'column', marginLeft: '10px' }}
                    >
                      <DcFlexBox
                        style={{
                          justifyContent: 'flex-start',
                          marginTop: '3px',
                          gap: '7px',
                        }}
                      >
                        <div>
                          <PixelIcon
                            style={{ marginBottom: '10px' }}
                            color={colors.black}
                            icon={faUser}
                          />
                        </div>
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            color: colors.black,
                          }}
                        >
                          {details?.billing?.first_name}
                          &nbsp;
                          {details?.billing?.last_name}
                        </div>
                      </DcFlexBox>
                      <DcFlexBox
                        style={{
                          justifyContent: 'flex-start',
                          marginTop: '3px',
                          gap: '5px',
                        }}
                      >
                        <div>
                          <PixelIcon
                            style={{ marginBottom: '10px' }}
                            color={colors.black}
                            icon={faPhone}
                          />
                        </div>
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            color: colors.black,
                          }}
                        >
                          {details?.billing?.phone}
                        </div>
                      </DcFlexBox>

                      <DcFlexBox
                        style={{
                          justifyContent: 'flex-start',
                          marginTop: '3px',
                          gap: '7px',
                        }}
                      >
                        <div>
                          <PixelIcon
                            style={{ marginBottom: '10px' }}
                            color={colors.black}
                            icon={faAt}
                          />
                        </div>
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            color: colors.black,
                          }}
                        >
                          {isItInvoice
                            ? customerData?.email
                            : details?.billing?.email}
                        </div>
                      </DcFlexBox>

                      <DcFlexBox
                        style={{
                          justifyContent: 'flex-start',
                          marginTop: '3px',
                          gap: '4px',
                        }}
                      >
                        <div>
                          <PixelIcon
                            style={{ marginBottom: '10px' }}
                            color={colors.black}
                            icon={faHouse}
                          />
                        </div>
                        <div
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            color: colors.black,
                          }}
                        >
                          {details?.billing?.address1} &nbsp;
                          <strong>
                            {details?.billing?.city}-
                            {details?.billing?.zip ||
                              details?.billing?.postcode}
                            -
                            {newOrder
                              ? details?.billing?.country_name
                              : details?.billing?.country}
                          </strong>
                        </div>
                      </DcFlexBox>
                    </DcFlexBox>
                  )
                )}
              </DcFlexBox>
            </>
          </>
        )}
      </>

      <DcOverlaySlider
        title={'Customer Orders History'}
        width={'70%'}
        onClose={() => setSummaryOrderHistory(false)}
        isOpen={summaryOrderHistory}
      >
        {summaryOrderHistory && (
          <SummaryTable
            details={details}
            detailID={detailID}
            handleClose={(data) => {
              setDetails(data)
              setSummaryOrderHistory(false)
            }}
          />
        )}
      </DcOverlaySlider>
      <DcOverlaySlider
        title={'Edit Address'}
        width={'70%'}
        onClose={() => setShowEditOrderAddress(false)}
        isOpen={showEditOrderAddress}
      >
        {showEditOrderAddress && (
          <EditCustomerInfo
            cities={cities}
            OrderAddresses={OrderAddresses}
            countries={countries}
            orderId={orderId}
            customerId={customerId}
            isSameAddress={true}
            setNewOrderData={setNewOrderData}
            setIsCustomerAdd={setIsCustomerAdd}
            newOrderData={newOrderData}
            newOrder={newOrder}
            setDetails={setDetails}
            details={details}
            handleClose={(data) => {
              if (data) {
                setDetails({
                  ...details,
                  is_billing_address_same: data?.is_billing_address_same,
                  shipping: data?.shipping,
                  billing: data?.billing,
                })
              }

              setShowEditOrderAddress(false)
            }}
          />
        )}
      </DcOverlaySlider>

      <DcOverlaySlider
        width={'70%'}
        title={'AddNewCustomer Customer'}
        onClose={() => setShowAddNewAddressPopup(false)}
        isOpen={showAddNewAddressPopup}
      >
        {showAddNewAddressPopup && (
          <AddNewCustomer
            isCustomerAdd={isCustomerAdd}
            setIsCustomerAdd={setIsCustomerAdd}
            countries={countries}
            handleClose={(data) => {
              setShowAddNewAddressPopup(false)
              setNewOrderData({
                ...data,
                billing: data.billing_address,
                shipping: data.shipping_address,
              })
              if (setCustomerData) {
                setCustomerData({
                  ...data,
                  billing: data.billing_address,
                  shipping: data.shipping_address,
                })
              }
            }}
          />
        )}
      </DcOverlaySlider>
    </Container>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  padding: 10px 0px;
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin: 0px 10px; */
`
const CloseButton = styled.div`
  padding: 10px;
  margin-right: 10px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.84);
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 10px;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }
`
const InnerSectionContent = styled.div<{ direction?: boolean; gap?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? 'row' : 'column')};
  gap: ${(props) => props.gap};
  margin: 10px;
`
const AddressItem = styled.div<{ color?: string }>`
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
`

const SectionBlock = styled.div<{ color?: string }>`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.87);
`
const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 3px;
  margin: 5px 0px;
`
const ChangeCustomer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const Left = styled.div``
const Right = styled.div``
const CustomTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
  margin: 10px;
`

export default CustomerInformation
